import { makeStyles } from '@mui/styles'
import { Button, Drawer, Paper, Stack, TextField, Typography } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'

import { EditCreateDisplayV2 } from '../../../Component/EditCreateDisplay/EditCreateDisplayV2'
import { GlobalDialog } from '../../../Component/GlobalDialog'
import SharedDialog from '../../../Component/common/dialog/SharedDialog'
import AppVersionList from '../AppVersionList'
import ReleasePickerDialog from '../components/AppVersionReleasePicker'
import VersionConfigListForm from '../components/VersionConfigListForm'
import { useAppVersionTemplate } from './hooks/useAppVersionTemplate'
import { getString } from '../../../helper/util'
import variables from '../../../styles/globalVariables.scss'

const { blackColor } = variables
const helperTextStyles = makeStyles(() => ({ root: { color: 'red !important' } }))

const resource = 'appVersionTemplatePage'

export default function AppVersionTemplateEdit() {
  const helperTextStylesClasses = helperTextStyles()

  const {
    template, lang, theme, isEdit,
    versionConfigList, inputError,
    drawerAppVersionOpen, setDrawerAppVersionOpen,
    customFilter, showDialog, setShowDialog,
    dialog, setDialog,
    onChangeInput, onChangeVersionConfigList,
    handleFolderMap, handleOnClickDrawer,
    onClickListRow, onClickVersionRow, onSelectRelease,
    releaseDialog, setReleaseDialog,
    onClickSave, onClickConfirmSave,
  } = useAppVersionTemplate()

  return (
    <>
      <EditCreateDisplayV2>
        <EditCreateDisplayV2.Header
          resource={resource}
          display={isEdit ? 'edit' : 'create'}
          code={template?.code ?? ''}
        />

        <EditCreateDisplayV2.Body>
          {/* ── Template meta ── */}
          <Stack spacing={2} sx={{ mb: 3 }}>
            <TextField
                sx={{}}
                size="small"
                label="Template Name"
                value={template?.code}
                onChange={(e) => onChangeInput('code', e.target.value)}
                error={!!inputError.code}
                helperText={inputError.code}
                required
                fullWidth
            />
            {/* <TextField
              size="small"
              label="Description"
              value={template.description}
              onChange={(e) => onChangeInput('description', e.target.value)}
              multiline
              rows={2}
              fullWidth
            /> */}
          </Stack>

          {/* ── Reusable version config form ── */}
          <VersionConfigListForm
            versionConfigList={versionConfigList}
            resource={resource}
            lang={lang}
            theme={theme}
            inputError={inputError}
            helperTextStylesClasses={helperTextStylesClasses}
            onChangeVersionConfigList={onChangeVersionConfigList}
            handleFolderMap={handleFolderMap}
            handleOnClickDrawer={handleOnClickDrawer}
          />

          {inputError.versionConfigList && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {inputError.versionConfigList}
            </Typography>
          )}
        </EditCreateDisplayV2.Body>

        <EditCreateDisplayV2.Footer>
          <Button variant="contained" startIcon={<SaveIcon />} onClick={onClickSave}>
            {getString(lang, '', 'save', theme)}
          </Button>
        </EditCreateDisplayV2.Footer>
      </EditCreateDisplayV2>

      {/* ── App Version Drawer ── */}
      <Drawer
        classes={{ paper: 'drawer-margin-left' }}
        anchor="right"
        open={drawerAppVersionOpen}
        onClose={() => setDrawerAppVersionOpen(false)}
      >
        <Paper>
          {customFilter && (
            <AppVersionList
              editBtn={false} createBtn={false} btnList={false}
              onClickListRow={onClickVersionRow}
              newListFilters={customFilter}
              dialogFooterBtn={
                <Button variant="contained" startIcon={<ClearIcon />} onClick={() => setDrawerAppVersionOpen(false)}>
                  {getString(lang, '', 'close', theme)}
                </Button>
              }
            />
          )}
        </Paper>
      </Drawer>

      {/* ── Release Picker Dialog ── */}
      <ReleasePickerDialog
        open={releaseDialog.open}
        onClose={() => setReleaseDialog({ open: false, versionGroup: null })}
        versionGroup={releaseDialog.versionGroup}
        buildTarget={releaseDialog.versionGroup?.buildTarget}
        onSelect={onSelectRelease}
      />

      {/* ── Confirm Dialog ── */}
      <SharedDialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        title="Confirm"
        content={<Typography>Are you sure you want to {isEdit ? 'update' : 'create'} this template?</Typography>}
        actions={
          <Stack direction="row" gap={1}>
            <Button variant="contained" onClick={onClickConfirmSave}>Confirm</Button>
            <Button variant="outlined" onClick={() => setShowDialog(false)}>Cancel</Button>
          </Stack>
        }
      />

      {dialog?.open && <GlobalDialog dialogInfo={dialog} />}
    </>
  )
}